import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from 'src/app/data.service';

/**
 *  HIÁNYZÁS-IGAZOLÁS – intézményi keret és igazgatói engedélyek.
 *
 *  A gondviselő tanévenként korlátozott számú napot igazolhat (keret). Minden
 *  igazolt nap beleszámít; a kereten felül a kérés ide kerül elbírálásra, és csak
 *  jóváhagyás után kerül rá az igazolás a hiányzott órákra.
 */
@Component({
  selector: 'app-igazolas',
  templateUrl: './igazolas.component.html',
  styleUrls: ['./igazolas.component.scss'],
})
export class IgazolasComponent implements OnInit {
  sajatIntezmeny: any;
  jogosult = false;

  keretNap = 5;
  keretMentes = false;

  kerelmek: any[] = [];
  elbiraltak: any[] = [];
  betoltes = false;
  /** Elutasításhoz kötelező indok – kérésenként külön mezőben gyűlik. */
  indokok: { [id: string]: string } = {};

  constructor(private http: HttpClient, private data: DataService) {}

  async ngOnInit() {
    this.sajatIntezmeny = await this.data.getFromStorage('sajatIntezmeny');
    const jogkor = await this.data.getJogkor();
    // A hozzáférés a Jogosultságok szerkesztőből jön, nem az 'admin' jogkör nevéből –
    // így más jogkör is megkaphatja ezt a képernyőt (/admin/igazolas).
    this.jogosult = (await this.data.hozzaferesek()).szabad('/admin/igazolas');
    this.beallitasBetolt();
    this.kerelmekBetolt();
  }

  get intezmenyId(): string {
    return String(this.sajatIntezmeny?.intezmenyId || this.sajatIntezmeny?.id || '').trim();
  }

  beallitasBetolt() {
    if (!this.intezmenyId) return;
    this.http.get<any>(`/api/hianyzas-igazolas/beallitas/${this.intezmenyId}`).subscribe({
      next: (r) => { this.keretNap = Number(r?.keret_nap ?? 5); this.szuloiElbiralas = !!r?.szuloi_elbiralas; },
      error: () => { /* az alapérték marad */ },
    });
  }

  keretMentesInditas() {
    const keret = Number(this.keretNap);
    if (!Number.isFinite(keret) || keret < 0) {
      this.data.sendToast('A keret csak nemnegatív szám lehet.', 'warning');
      return;
    }
    this.keretMentes = true;
    this.http.put<any>(`/api/hianyzas-igazolas/beallitas/${this.intezmenyId}`, { keret_nap: keret })
      .subscribe({
        next: () => {
          this.keretMentes = false;
          this.data.sendToast(`A szülői igazolás kerete ${keret} nap lett.`);
        },
        error: (e) => {
          this.keretMentes = false;
          this.data.sendToast(e?.error?.error || 'A mentés nem sikerült.', 'error');
        },
      });
  }

  szuloiElbiralas = false;

  elbiralasMentes() {
    this.http.put<any>(`/api/hianyzas-igazolas/beallitas/${this.intezmenyId}`, { szuloi_elbiralas: this.szuloiElbiralas })
      .subscribe({
        next: () => this.data.sendToast(this.szuloiElbiralas
          ? 'Mostantól a szülői igazolást is az osztályfőnök bírálja el.'
          : 'A kereten belüli szülői igazolás ismét azonnal érvényes.'),
        error: (e) => this.data.sendToast(e?.error?.error || 'A mentés nem sikerült.', 'error'),
      });
  }

  kerelmekBetolt() {
    if (!this.intezmenyId) return;
    this.betoltes = true;
    this.http.get<any[]>(`/api/hianyzas-igazolas/engedelyek/${this.intezmenyId}`).subscribe({
      next: (r) => {
        const ujak = Array.isArray(r) ? r : [];
        this.kerelmek = [...this.kerelmek.filter((x) => x.statusz !== 'engedelyre_var'), ...ujak];
        this.betoltes = false;
      },
      error: () => { this.betoltes = false; this.data.sendToast('Nem sikerült betölteni a kéréseket.', 'error'); },
    });
    //  A mellékelt orvosi / hivatalos igazolás elsősorban az osztályfőnöké, de ha ott
    //  elakad, itt is elbírálható – ne maradjon gazdátlanul.
    this.http.get<any[]>(`/api/hianyzas-igazolas/engedelyek/${this.intezmenyId}?statusz=elbiralasra_var`)
      .subscribe({
        next: (r) => {
          const ujak = Array.isArray(r) ? r : [];
          this.kerelmek = [...this.kerelmek.filter((x) => x.statusz !== 'elbiralasra_var'), ...ujak];
        },
        error: () => { /* a dokumentumos kérések listája kiegészítő */ },
      });
    // Az elbírált kérések listája (visszakereshetőség miatt)
    for (const statusz of ['igazolt', 'elutasitva']) {
      this.http.get<any[]>(`/api/hianyzas-igazolas/engedelyek/${this.intezmenyId}?statusz=${statusz}`)
        .subscribe({
          next: (r) => {
            const ujak = (Array.isArray(r) ? r : []).filter((x) => x.elbiralo);
            this.elbiraltak = [...this.elbiraltak.filter((x) => x.statusz !== statusz), ...ujak]
              .sort((a, b) => String(b.elbiralas).localeCompare(String(a.elbiralas)));
          },
          error: () => { /* a listázás nem kritikus */ },
        });
    }
  }

  dontes(kerelem: any, dontes: 'jovahagy' | 'elutasit') {
    const indok = String(this.indokok[kerelem.id] || '').trim();
    if (dontes === 'elutasit' && !indok) {
      this.data.sendToast('Elutasításnál az indoklás kötelező – a szülő ezt fogja látni.', 'warning');
      return;
    }
    this.http.post<any>(`/api/hianyzas-igazolas/engedely/${kerelem.id}`, { dontes, indok })
      .subscribe({
        next: () => {
          this.data.sendToast(dontes === 'jovahagy' ? 'Engedélyezve, az igazolás felkerült.' : 'Elutasítva.');
          this.elbiraltak = [];
          this.kerelmekBetolt();
        },
        error: (e) => this.data.sendToast(e?.error?.error || 'A döntés nem sikerült.', 'error'),
      });
  }
}
